var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ReactComponent as BackgroundCircles } from '@backrs_ui/common-ui/src/assets/images/background-circles.svg';
import { Box, Dialog } from '@mui/material';
import { AppIcon } from '../designSystem/icons/AppIcon';
import { FeaturedIcon } from '../designSystem/icons/FeaturedIcon';
export var InfoView = function (_a) {
    var onClose = _a.onClose, headerContent = _a.headerContent, _b = _a.headerInLineWithIcon, headerInLineWithIcon = _b === void 0 ? false : _b, bodyContent = _a.bodyContent, _c = _a.icon, icon = _c === void 0 ? 'InfoCircle' : _c, _d = _a.featuredIcon, featuredIcon = _d === void 0 ? {
        iconName: icon,
        size: 'lg',
        color: 'Colors/Foreground/fg-secondary',
    } : _d, _e = _a.hideCircleImage, hideCircleImage = _e === void 0 ? false : _e, headerVisual = _a.headerVisual, _f = _a.showBottomBorder, showBottomBorder = _f === void 0 ? false : _f, bodyContainerSx = _a.bodyContainerSx, _g = _a.variant, variant = _g === void 0 ? 'light' : _g, _h = _a.fitViewport, fitViewport = _h === void 0 ? false : _h;
    var isDark = variant === 'dark';
    return (_jsxs(Box, { sx: containerSx(!!bodyContainerSx, isDark, fitViewport), children: [_jsxs(Box, { sx: headerSx(!!headerContent, showBottomBorder, !!bodyContainerSx, isDark, fitViewport), children: [!!headerContent && !hideCircleImage && !isDark && (_jsx(Box, { sx: backgroundCirclesSx, children: _jsx(BackgroundCircles, {}) })), _jsxs(Box, { sx: iconsSx(!!headerContent), children: [!!headerContent && !isDark && (_jsxs(Box, { sx: featuredIconAndOptionalHeaderContentSx, children: [headerVisual !== null && headerVisual !== void 0 ? headerVisual : _jsx(FeaturedIcon, __assign({}, featuredIcon)), headerInLineWithIcon && headerContent] })), !!headerContent && isDark && headerInLineWithIcon && headerContent, onClose && (_jsx(Box, { id: "info-modal-close-button", sx: closeIconSx(!!headerContent), onClick: onClose, children: _jsx(AppIcon, { iconName: "XClose", diameter: "20px", color: isDark ? 'Colors/Base/White' : 'Colors/Foreground/fg-quaternary' }) }))] }), !headerInLineWithIcon && headerContent] }), _jsx(Box, { sx: fitViewport
                    ? [fitBodySx, bodyContainerSx].filter(Boolean)
                    : bodyContainerSx, children: bodyContent })] }));
};
export var InfoModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, _b = _a.width, width = _b === void 0 ? 'md' : _b, headerContent = _a.headerContent, _c = _a.headerInLineWithIcon, headerInLineWithIcon = _c === void 0 ? false : _c, bodyContent = _a.bodyContent, dialogSx = _a.dialogSx, icon = _a.icon, featuredIcon = _a.featuredIcon, headerVisual = _a.headerVisual, _d = _a.hideCircleImage, hideCircleImage = _d === void 0 ? false : _d, _e = _a.showBottomBorder, showBottomBorder = _e === void 0 ? false : _e, bodyContainerSx = _a.bodyContainerSx, _f = _a.variant, variant = _f === void 0 ? 'light' : _f, _g = _a.fitViewport, fitViewport = _g === void 0 ? false : _g;
    return (_jsx(Dialog, { className: "info-modal-dialog", open: open, onClose: onClose, sx: [dialogStyle, fitViewport && fitViewportDialogStyle, dialogSx].filter(Boolean), maxWidth: width, fullWidth: true, children: _jsx(InfoView, { onClose: onClose, headerContent: headerContent, headerInLineWithIcon: headerInLineWithIcon, bodyContent: bodyContent, hideCircleImage: hideCircleImage, icon: icon, featuredIcon: featuredIcon, headerVisual: headerVisual, showBottomBorder: showBottomBorder, bodyContainerSx: bodyContainerSx, variant: variant, fitViewport: fitViewport }) }));
};
var containerSx = function (hasCustomBodySx, isDark, fitViewport) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign(__assign(__assign({ display: 'flex', flexDirection: 'column', overflow: 'hidden' }, (fitViewport ? { flex: 1, minHeight: 0 } : { overflowY: 'auto' })), (!hasCustomBodySx && {
            p: backrs.spacing['spacing-3xl'],
        })), (isDark && {
            backgroundColor: backrs.colors['Colors/Background/bg-primary'],
        })));
    };
};
var fitBodySx = {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
};
var fitViewportDialogStyle = {
    '& .MuiDialog-paper': {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
};
var headerSx = function (hasHeaderContent, showBottomBorder, hasCustomBodySx, isDark, fitViewport) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign(__assign(__assign(__assign(__assign({ position: 'relative', width: '100%' }, (fitViewport && { flexShrink: 0 })), (hasCustomBodySx && {
            px: backrs.spacing['spacing-3xl'],
            pt: backrs.spacing['spacing-3xl'],
        })), (showBottomBorder && {
            marginX: -backrs.spacing['spacing-3xl'],
            borderBottom: "1px solid ".concat(backrs.colors['Colors/Border/border-primary']),
        })), (hasHeaderContent && {
            mb: isDark ? 0 : backrs.spacing['spacing-2xl'],
        })), (isDark && {
            backgroundColor: backrs.colors['Colors/Base/Black'],
            px: backrs.spacing['spacing-3xl'],
            pt: backrs.spacing['spacing-2xl'],
            pb: backrs.spacing['spacing-xl'],
        })));
    };
};
var iconsSx = function (hasHeaderContent) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign({ zIndex: 0, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }, (hasHeaderContent && {
            mb: backrs.spacing['spacing-xl'],
            justifyContent: 'space-between',
        })));
    };
};
var closeIconSx = function (hasHeaderContent) {
    return function () { return (__assign({ cursor: 'pointer', justifySelf: 'flex-end' }, (!hasHeaderContent && {
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 1000,
    }))); };
};
var backgroundCirclesSx = {
    position: 'absolute',
    top: -(336 * 0.425),
    left: -(336 * 0.425),
    zIndex: 0,
};
var dialogStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        '& .MuiDialog-paper': {
            borderRadius: backrs.radius['radius-xl'],
            boxShadow: backrs.shadows['shadow-xl'],
            border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
        },
    });
};
var featuredIconAndOptionalHeaderContentSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: backrs.spacing['spacing-2xl'],
    });
};
